module.exports = __webpack_public_path__ + "img/template003.ff2135bb.png";